import { normalizeSpringDataPage } from "tap/utils/pagination.js";

/**
 * Builds a consistent Redux update from a TPR Exceptions page API response.
 */
export function buildTprExceptionsPageUpdate(
  data,
  {
    itemsPerPage,
    currentPage,
    range,
    previousTotalItems,
    preserveTotal = false,
  },
) {
  const meta = normalizeSpringDataPage(data, itemsPerPage);

  let totalItems;
  if (preserveTotal) {
    totalItems = previousTotalItems ?? 0;
  } else if (data?.totalElements != null) {
    totalItems = data.totalElements;
  } else {
    totalItems = 0;
  }

  const totalPages =
    preserveTotal && totalItems > 0
      ? Math.ceil(totalItems / itemsPerPage)
      : meta?.totalPages ?? data?.totalPages;

  return {
    tprExceptions: data?.content,
    tprExceptionsRange: range,
    currentPage:
      currentPage ??
      meta?.currentPage ??
      data?.pageable?.pageNumber ??
      0,
    totalPages,
    totalItems,
  };
}
